<template>
  <div class="account-management-wrapper">
    <!-- 头部 -->
    <mobile-header>
      <i slot="arrowLeft" class="el-icon-arrow-left" @click="$router.go(-1)"></i>
      <span slot="title" class="text">账号管理</span>
    </mobile-header>

    <div class="main-content">
      <div class="account-card">
        <!-- 手机号行 -->
        <div class="info-row">
          <span class="label">手机号码</span>
          <span class="value">{{ maskedPhone }}</span>
          <button class="change-btn" @click="changePhone">变更</button>
        </div>

        <div class="divider"></div>

        <!-- 注销账号 -->
        <button class="delete-btn" @click="deleteAccount">注销账号</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import MobileHeader from '@/components/mobile/MobileHeader.vue'; // ✅ 修正为正确的路径

export default {
  name: 'AccountManagement',
  components: { MobileHeader },
  computed: {
    ...mapState(['user']),
    maskedPhone() {
      const phone = this.user.phoneNumber || '';
      if (!phone) return '未绑定';
      // 脱敏：保留前3位和后4位，中间4位用 **** 代替
      return phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
    }
  },
  methods: {
    changePhone() {
      this.$message.info('修改手机号功能开发中');
      // 后续可扩展：this.$router.push('/change-phone');
    },
    deleteAccount() {
      this.$confirm('注销账号后所有数据将被永久删除且无法恢复，确定要继续吗？', '危险操作', {
        confirmButtonText: '确定注销',
        cancelButtonText: '取消',
        type: 'warning',
        confirmButtonClass: 'el-button--danger'
      }).then(async () => {
        try {
          // 调用注销 API（示例）
          // await deleteAccountAPI();
          this.$message.success('账号已注销');
          await this.logout();
        } catch (error) {
          this.$message.error('注销失败，请稍后再试');
        }
      }).catch(() => {});
    },
    async logout() {
      this.$store.commit('removeUser');
      this.$store.commit('removeToken');
      this.$store.commit('CLEAR_MESSAGE');
      this.$router.replace('/login');
    }
  }
};
</script>

<style lang="scss" scoped>
.account-management-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100dvh;
  background-color: var(--bg-color-3);
  color: var(--txt-default-color);
  padding: 0 10px;
  box-sizing: border-box;

  .main-content {
    display: flex;
    justify-content: center;
    padding-top: 20px;
  }

  .account-card {
    width: 100%;
    max-width: 400px;
    background: var(--leftbox-bg-color);
    border-radius: 16px;
    padding: 24px 20px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);

    .info-row {
      display: flex;
      align-items: center;
      gap: 12px;

      .label {
        font-weight: 500;
        color: var(--gray-6);
        font-size: 15px;
        white-space: nowrap;
      }

      .value {
        font-size: 16px;
        font-weight: 600;
        color: var(--txt-default-color);
        flex: 1;
        text-align: left;
      }

      .change-btn {
        padding: 6px 16px;
        border-radius: 8px;
        border: 1px solid var(--border-color);
        background: transparent;
        color: var(--txt-default-color);
        cursor: pointer;
        font-size: 13px;
        transition: all 0.2s;

        &:hover {
          background: var(--bg-color-3);
          border-color: var(--gray-4);
        }
      }
    }

    .divider {
      height: 1px;
      background: var(--border-color);
      margin: 20px 0;
    }

    .delete-btn {
      width: 100%;
      padding: 14px 0;
      background: #ef4444;
      color: #fff;
      border: none;
      border-radius: 12px;
      font-weight: 600;
      font-size: 16px;
      cursor: pointer;
      transition: background 0.2s, transform 0.1s;

      &:hover {
        background: #dc2626;
      }

      &:active {
        transform: scale(0.97);
      }
    }
  }
}

@media (max-width: 750px) {
  .account-management-wrapper {
    padding: 0 10px;
  }
}
</style>